$w.onReady(function() {
// Put all your $w code here

$w("#button21").onClick(() => {
    $w("#Box").changeState("Open");
});

$w("#button22").onClick(() => {
    $w("#Box").changeState("Closed");
});
});